import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleRightMedium"><Path d="M17.5625 12L9 19.1348V4.86523L17.5625 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
